import Api from 'services/apiService.js';
import {
  REFRESH_TOKEN,
  GET_AUTH_PROVIDER_URL,
  SEND_EXTERNAL_AUTH_TOKEN,
  LOGIN,
  SEND_PASSWORD_RESET_EMAIL,
  UPDATE_PASSWORD,
} from 'actionTypes';

const AUTH_TYPE_URL_MAP = {
  login: 'login',
  register: 'signup',
};

function oauthProviderEndpoint(endpointArgs) {
  const { provider } = endpointArgs;
  return `accounts/${provider}/login/auth`;
}

function oauthTokenEndpoint(endpointArgs) {
  const { provider, authType } = endpointArgs;
  return `accounts/${provider}/${AUTH_TYPE_URL_MAP[authType]}/callback`;
}

export default {
  [REFRESH_TOKEN]: {
    endpoint: 'token/refresh',
    apiFunc: Api.post,
  },
  [GET_AUTH_PROVIDER_URL]: {
    endpoint: oauthProviderEndpoint,
    apiFunc: Api.get,
  },
  [SEND_EXTERNAL_AUTH_TOKEN]: {
    endpoint: oauthTokenEndpoint,
    apiFunc: Api.post,
  },
  [LOGIN]: {
    endpoint: 'login',
    apiFunc: Api.post,
  },
  [SEND_PASSWORD_RESET_EMAIL]: {
    endpoint: 'user/password/reset',
    apiFunc: Api.post,
  },
  [UPDATE_PASSWORD]: {
    endpoint: 'user/password/update',
    apiFunc: Api.put,
  },
};



// WEBPACK FOOTER //
// ./src/endpoints/authEndpoints.js